import React from 'react';
import { handleActions } from 'redux-actions';
import update from 'immutability-helper';
import * as ActionTypes from '../../../constants/ActionTypes';
import { merge, set as setPath } from 'lodash';

const initialState = {
    policyUrls: {}
};

export const policyUrlsReducer = handleActions(
    {
        // eslint-disable-next-line import/namespace
        [ActionTypes.CONFIG_POLICY_URL_CHANGE]: (state, action) => {
            if (action.theme.hasOwnProperty('policyUrls')) {
                return { ...state, policyUrls: action.config.policyUrls };
            } else {
                return state;
            }
        }
    },
    initialState
);

export default policyUrlsReducer;



// WEBPACK FOOTER //
// ./src/reducers/theme/data/policy-urls.js